import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  GcCheckboxComponent,
  GcModalComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { DetailedErrorFeedbackAlertComponent } from '../../feedback-alert/detailed-error-feedback-alert/detailed-error-feedback-alert.component';
import { FeedbackAlertComponent } from '../../feedback-alert/feedback-alert.component';

export type CompleteReportConfirmationState = 'accept' | 'completed';

@Component({
  selector: 'app-complete-report-confirmation-modal',
  imports: [
    GcModalComponent,
    GcTextComponent,
    GcCheckboxComponent,
    IpoTranslatePipe,
    FeedbackAlertComponent,
    DetailedErrorFeedbackAlertComponent,
  ],
  templateUrl: './complete-report-confirmation-modal.component.html',
  styleUrl: './complete-report-confirmation-modal.component.scss',
})
export class CompleteReportConfirmationModalComponent implements OnChanges {
  @Input({ required: true }) state!: CompleteReportConfirmationState;
  @Input() isLoading = false;

  @Output() confirmed = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  checked = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['state'] && this.state === 'accept') {
      this.checked = false;
    }
  }

  toggleCheckbox(): void {
    this.checked = !this.checked;
  }

  onPrimaryButtonClick(): void {
    if (this.state === 'completed') {
      this.dismissed.emit();
      return;
    }
    if (this.checked && !this.isLoading) {
      this.confirmed.emit();
    }
  }

  onDismiss(): void {
    if (!this.isLoading) {
      this.dismissed.emit();
    }
  }
}
